<template>
  <div class="about" id="about">
    <v-app>
      <v-app-bar
      app
      color='primary'
      dark
      height="564"
      absolute
      >
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor" :pc='pc'></FirstNavbar>
          <div class="first_title_box" style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  关于我们
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_about.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <v-app-bar
          :fixed='second_bar_fixed'
          prominent
          height="64"
          color="white"
          :flat='!second_bar_fixed'
        >
          <v-tabs v-model="second_active_tab" centered>
            <v-tab v-for="tab in contentList" :key='tab.index'  @click="goTo(tab.index)" class="body_text">{{tab.firstTitle}}</v-tab>
          </v-tabs>
        </v-app-bar>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <!-- 公司简介 -->
              <BoxTitle :firstTitle="contentList[0].firstTitle" :desc="contentList[0].desc" :index="contentList[0].index"></BoxTitle>
              <BoxLr :data='contentList[0].children[0]' :left_img="false"></BoxLr>
              <!-- 愿景及使命 -->
              <BoxTitle :firstTitle="contentList[1].firstTitle" :desc="contentList[1].desc" :index="contentList[1].index"></BoxTitle>
              <BoxLr :data='contentList[1].children[0]' :left_img="true"></BoxLr>
              <!-- 嘉旭福美数字经济产业园 -->
              <BoxTitle :firstTitle="contentList[2].firstTitle" :desc="contentList[2].desc" :index="contentList[2].index"></BoxTitle>
              <BoxLr :data='contentList[2].children[0]' :left_img="false"></BoxLr>
              <!-- <BoxLr :data='contentList[2].children[1]' :left_img="true"></BoxLr> -->
              <!-- 生态科学实验基地 -->
              <BoxTitle :firstTitle="contentList[3].firstTitle" :desc="contentList[3].desc" :index="contentList[3].index"></BoxTitle>
              <BoxLr :data='contentList[3].children[0]' :left_img="true"></BoxLr>
              <BoxLr :data='contentList[3].children[1]' :left_img="false"></BoxLr>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxLr from '../components/box-lr.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'about',

  components: {
    FootContent,
    FirstNavbar,
    BoxLr,
    BoxTitle
  },

  data: () => ({
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 是否为PC端
    pc: false,
    // 导航栏是否隐藏
    barHide: true,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 0,
    // 内容列表
    contentList: [{
      index: 1,
      firstTitle: '公司简介',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'about_jianjie.jpg',
        content: {
          title: '',
          body: '嘉旭福美公司以云计算应用和大数据分析为核心业务，致力于数字经济发展，涵盖数字资源、数字融合、运营服务，依托先进的技术和资源，为用户提供专业系统解决方案和优质平台，以及数据增值服务',
          list: [],
          btn: ''
        }
      }]
    }, {
      index: 2,
      firstTitle: '愿景及使命',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'about_yuanjing.jpg',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '企业使命：智慧改变生活  数据承载未来  发展智慧产业  展现科技力量',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            title: '企业愿景：创立信息化领域的著名品牌,成为最优秀的软件产品和大数据应用服务商',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 3,
      firstTitle: '嘉旭福美数字经济产业园',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'chanyeyuan.jpg',
        content: {
          title: '',
          body: '嘉旭福美数字经济产业园以发展数字经济新业态、形成数据产业效应为目标，综合产学研站，旨在研究数据分析新技术，探索数据应用价值，充分发挥中国大数据产业联盟的行业汇聚效应和服务雄安的引领作用',
          list: [],
          btn: {
            label: '了解更多',
            path: '/yuanqu'
          }
        }
      }, {
        index: 2,
        src: 'chanyeyuan2.png',
        content: {
          title: '',
          body: '以新型数字网络（IPV6）为基础，以数据有效利用为重点，探索数字经济新业态，以形成数据产业汇聚效应为目标。结合产学研站，旨在研究数据分析新技术。探索数字经济新形态的数据应用价值。<br>以数字融合应用板块为核心，建设绿色、生态、低碳、现代、可持续发展的数字经济产业园区',
          list: [],
          btn: ''
        }
      }]
    }, {
      index: 4,
      firstTitle: '生态科学实验基地',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'about_shengtaita.jpg',
        content: {
          title: '',
          body: '定兴县生态文明科学实验基地由嘉旭福美与中国科学院地理科学与资源研究所、定兴县政府三方联合组建。目前，定兴生态观测站已被列入中国科学院雄安新区国际领先水平的现代地理综合研究超级站卫星站',
          list: [],
          btn: {
            label: '了解更多',
            path: '/shengtaijidi'
          }
        }
      }, {
        index: 1,
        src: '生态基地.gif',
        content: {
          title: '生态科学大数据分析平台',
          body: '平台集数据采集、清洗、存储、建模、可视化为一体，实现对大气、土壤、水等多要素数据的实时观测，运用大数据在数据分析方面的优势，结合模型模拟先进技术，针对各类生态系统进行多尺度、多过程、精细化的挖掘分析，为生态环境的决策管理提供科学依据',
          list: [],
          btn: ''
        }
      }]
    }],
    // 二级导航选项卡
    second_active_tab: 0,
    secondTabs: [
      { id: 1, name: 'part1', label: '公司简介', scrollTop: '' },
      { id: 2, name: 'part2', label: '愿景及使命', scrollTop: '' },
      { id: 3, name: 'part3', label: '福美数字经济产业园', scrollTop: '' },
      { id: 4, name: 'part4', label: '生态科学实验基地', scrollTop: '' }
    ],
    // 二级导航是否冻结
    second_bar_fixed: false,
    // 历程
    model: 2
  }),
  mounted () {
    this.goTo(0)
    // // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.secondTabs.forEach((val, index, arry) => {
      this.secondTabs[index].scrollTop = this.$el.querySelector('#' + this.secondTabs[index].name).offsetTop + 500
    })
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },

  methods: {
  // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.second_bar_fixed = true
        this.gotop = true
      } else {
        this.second_bar_fixed = false
        this.barColor = 'rgba(63, 81, 181,0)'
        this.gotop = false
      }
      if (scrollTop >= this.secondTabs[3].scrollTop) {
        this.second_active_tab = 3
        this.floatHidden = false
      } else if (scrollTop >= this.secondTabs[2].scrollTop & scrollTop < this.secondTabs[3].scrollTop) {
        this.second_active_tab = 2
        this.floatHidden = false
      } else if (scrollTop >= this.secondTabs[1].scrollTop & scrollTop < this.secondTabs[2].scrollTop) {
        this.second_active_tab = 1
        this.floatHidden = false
      } else if (scrollTop >= this.secondTabs[0].scrollTop & scrollTop < this.secondTabs[1].scrollTop) {
        this.second_active_tab = 0
        this.floatHidden = false
      } else {
        this.second_active_tab = 0
        this.floatHidden = true
      }
    },
    goTo (index) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      // document.documentElement.scrollTop = anchor.offsetTop + 500
      if (index === 0) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
        document.documentElement.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
      }
    }
  }

}
</script>

<style>

</style>
